module.exports = __webpack_public_path__ + "img/Cell.55ff4673.png";